module.exports = __webpack_public_path__ + "img/win_back.13766729.319ed35d.png";